<template>
    <form data-testid="observer-form" novalidate @submit.prevent="!loading && onSubmit()">
      <SLoadingOverlay :loading="loading && !hideCover" :scrim="scrim" />
      <ErrorContainer v-if="!noerror" :messages="errorMessages" />
      <slot  />
    </form>
</template>

<script lang="ts" setup>
import { useForm } from 'vee-validate'
import ErrorContainer from '~/components/base/ErrorContainer.vue'

interface Props {
 slim?: boolean
 noerror?: boolean
 loading?: boolean
 /** Translucent loading cover instead of opaque white; see SLoadingOverlay. AB#64268 */
 scrim?: boolean
 /** Hide the loading cover but keep `loading` blocking submit: a held join step during a
  * step change, when the layout's cover dims the page instead. AB#64268 */
 hideCover?: boolean
 errorMessages?: string[]
}

withDefaults(defineProps<Props>(), {
  slim: true,
  noerror: false,
  loading: false,
  scrim: false,
  hideCover: false,
  errorMessages: () => []
})

const emits = defineEmits<{
  (e: 'submit'): void
  (e: 'changed', flags: Record<string, unknown>): void
}>()

const submit = () => {
  emits('submit')
}

const { handleSubmit, resetForm, validate, meta, submitCount } = useForm()
const onSubmit = handleSubmit(submit)

watch(submitCount, () => {
  emits('changed', meta.value as unknown as Record<string, unknown>)
})
const forceValidate = async () => {
  await nextTick()
  return validate()
}

defineExpose({ resetForm, validate, forceValidate })
</script>
